import { RespondentType } from '../../models/questions';
import { CheckoutState } from '../../state';
import { getSurveyType } from '../event';
import { getArePostCheckoutMandatoryQuestionsFlowRulesForExpressCheckoutMet } from './getArePostCheckoutMandatoryQuestionsFlowRulesForExpressCheckoutMet';
import { getHasRequiredQuestions } from './pureSelectors';

export const getAreAsyncExpressCheckoutEligibleCommonRulesMet = (
    state: CheckoutState,
) =>
    (!getHasRequiredQuestions(state) &&
        [RespondentType.buyer, RespondentType.direct].includes(
            getSurveyType(state),
        )) ||
    getArePostCheckoutMandatoryQuestionsFlowRulesForExpressCheckoutMet(state);
